import MockAdapter from 'axios-mock-adapter';
// import { invoiceManagementData, detailInvoice } from './demo_data';

const mockAxios = ax => {
  if (process?.env?.REACT_APP_IS_LOCAL) {
    // eslint-disable-next-line no-console
    console.log('THIS IS LOCAL BUILD!!!!');
    // eslint-disable-next-line no-console
    console.log('SOME REQUESTS WILL BE MOCKED!');
    const mock = new MockAdapter(ax, {
      onNoMatch: 'passthrough',
      delayResponse: 1000
    });
    // Inline comparison, not isRemediationMockEnabled(): webpack can only fold a literal
    // `process.env.X === 'true'`, which is what keeps the mock out of production builds
    // (see craco.config.js)
    if (process.env.REACT_APP_MOCK_REMEDIATION === 'true') {
      // eslint-disable-next-line global-require
      const remediationMocks = require('../pages/facilityProfile2/remediationCases/mock/releasesMock');
      remediationMocks.registerRemediationMocks(mock);
    }
    // mock
    //   .onGet(new RegExp(`https://local-front.proteanapp.com/api/v3/invoice/get_invoice/*`))
    //   .reply(200, detailInvoice);
    // mock
    //   .onGet(new RegExp(`https://local-front.proteanapp.com/api/v3/invoices?/*`))
    //   .reply(200, invoiceManagementData);
    // // eslint-disable-next-line no-console
    console.log(mock);
  }
};

export default mockAxios;
